import store from '../../store';

import Modal from '../common/dialog/dialog.vue';
import Checkbox from '../common/checkbox/checkbox.vue';
import Player from '../common/clip-player/clip-player.vue';
import Lookup from '../common/lookup/lookup.vue';
import AddToCart from '../add-to-cart/add-to-cart.vue';

import { source } from '../../mixins/player.sources.mixin';

import { required, minLength } from 'vuelidate/lib/validators';

import find from 'lodash/find';
import map from 'lodash/map';
import filter from 'lodash/filter';
import flatten from 'lodash/flatten';

import l10n from '../../transformers/l10n';

import { METADATA_TYPES } from '../../config';

export default {
   store,
   components: { Modal, Player, Checkbox, AddToCart, Lookup },
   data() {
      return {
         clipId: null,
         synopsis: '',
         tcIn: null,
         tcOut: null,
         sources: null,
         cart: null,
         episodeId: null,
         mustUseCart: true,
         groups: {},
         disabled: false,

         opts: {
            confirmText: '',
            showHeader: false,
            canConfirmChecker: this.canConfirmChecker
         }
      };
   },
   computed: {
      isAdmin() {
         const user = this.$store.getters.getCurrentUser;
         return user.roles.some(r => r === 'admin');
      },
      resolvedValue() {
         const metadata = flatten(map(this.groups, 'list'));
         return {
            cart: this.cart,
            clip: {
               id: this.clipId,
               episodeId: this.episodeId,
               synopsis: this.synopsis,
               tcIn: this.tcIn,
               tcOut: this.tcOut,
               metadata: map(metadata, ({ type, id, name }) => {
                  return {type, id, name};
               })
            }
         };
      }
   },
   validations: {
      synopsis: {
         required,
         minLength: minLength(4) // eslint-disable-line no-magic-numbers
      }
   },
   methods: {
      onChangeCart(cart) {
         this.cart = cart;
      },
      loaderForType(type) {
         return search => this.$options.searchMetadata(type, search);
      },
      changerForType(type, list) {
         const group = find(this.groups, { type });
         group.list = list;
      },
      canConfirmChecker() {
         this.$v.$touch();
         return !this.$v.$error;
      },
      createNewMetadata(type, event) {
         const name = event.target.value.trim();
         if (!name) {
            return;
         }
         if (type === 'character'){
            return;
         }
         const group = find(this.groups, { type });
         const list = group.list;
         list.push({ name, type });
         group.list = list;
         event.target.value = '';
      }
   },
   mounted() {
      const { episode, clip, mustUseCart, confirmText, headerText, disabled } = this.$options;
      const { tcIn, tcOut, metadata, synopsis } = clip;
      // this.name      = name;
      this.synopsis  = synopsis;
      this.tcIn      = tcIn;
      this.tcOut     = tcOut;
      this.episodeId = episode.id;
      this.clipId    = clip.id;
      this.mustUseCart = mustUseCart;
      this.disabled  = disabled;

      this.sources = source(episode);

      if (this.isAdmin) {
         this.groups = map( METADATA_TYPES, ({type, tk}) => {
            const name = l10n(tk);
            return { type, name, list: filter(metadata, { type }) };
         });
      }

      this.opts.confirmText = confirmText || l10n('clip.create_btn');
      this.opts.showConfirm = !disabled;
      this.opts.headerText = headerText || l10n('clip.create_header');
   }
};
